<template>
  <div class="projects-media-update">
    <v-overlay :value="!hasLoaded">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>

    <div
      v-if="hasLoaded"
      class="icon__container"
      @click="$router.go(-1)"
    >
      <v-icon color="#880e4f">
        mdi-arrow-left
      </v-icon>
    </div>

    <app-drawing-zone
      v-if="hasLoaded"
      :drawing.sync="drawing"
      :background-layer="backgroundLayer"
      @click-camera="$router.push({ name: 'app-camera-tool' })"
      @delete-background="deleteBackground"
      @save="save"
    />
  </div>
</template>

<script>
import { AppDrawingZone } from "../../shared/components";
import ErrorHandlingMixin from "@/mixins/ErrorHandlingMixin.vue";

export default {
  name: "AppProjectsMediaUpdate",
  components: {
    AppDrawingZone
  },

  mixins: [ErrorHandlingMixin],

  data() {
    return {
      hasLoaded: false,
      media: {}
    };
  },

  computed: {
    // Selected media uuid in Vuex
    selectedMedia: {
      get() {
        return this.$store.state.medias.selectedMedia;
      },

      set(value) {
        this.$store.commit("medias/SET_SELECTED_MEDIA", value);
      }
    },

    // Background layer for then canvas (usually an image)
    backgroundLayer: {
      get() {
        return this.$store.state.medias.backgroundLayer;
      },

      set(value) {
        this.$store.commit("medias/SET_BACKGROUND_LAYER", value);
      }
    },

    // The drawing (aka draw, aka painting, aka paint)
    drawing: {
      get() {
        return this.$store.state.medias.drawing;
      },

      set(value) {
        this.$store.commit("medias/SET_DRAWING", value);
      }
    },

    // Final image (drawing + background layer)
    // Better to work and keep aspect ratio right 'cause its just an image
    finalImage: {
      get() {
        return this.$store.state.medias.finalImage;
      },

      set(value) {
        this.$store.commit("medias/SET_FINAL_IMAGE", value);
      }
    }
  },

  async mounted() {
    await this.init();
    this.hasLoaded = true;
  },

  beforeDestroy() {
    this.drawing = null;
    this.backgroundLayer = null;
    this.finalImage = null;
  },

  methods: {
    // Set background layer to null
    deleteBackground() {
      this.media.image = null;
      this.backgroundLayer = null;
    },

    // Update media
    async save(data_uri) {
      try {
        // New object to update
        let media = {
          croquis: this.drawing,
          image: this.backgroundLayer,
          final_image: data_uri
        };

        // Result would be 1 if success, 0 otherwise
        await this.$db.medias.update(this.selectedMedia, media);

        this.$notify({
          group: "main",
          type: "success",
          title: "Succès",
          text: "Media enregistré",
          duration: 5000
        });
      } catch (e) {
        const errorMsg =
          "Le média n'a pas pu être enregistré. Réessayer ultérieurement";
        this.handleError(e, errorMsg); // TODO: Send error to server
        console.error(e);
      }
    },

    // Get media from IndexedDB
    async init() {
      try {
        const media = await this.$db.medias.get(this.selectedMedia);

        this.media = media;
        this.drawing = media.croquis;

        if (this.backgroundLayer == null) {
          this.backgroundLayer = media.image;
        }

        this.finalImage = media.final_image;

        // Return promise. Usefull for waiting on load that all tha we need is loaded
        return Promise.resolve();
      } catch (e) {
        const errorMsg = "Nous n'avons pas réussi à touvé le media";
        this.handleError(e, errorMsg); // TODO: Send error to server
        console.error(e);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.projects-media-update {
  height: 100%;
  display: flex;
  justify-content: center;

  .icon__container {
    position: absolute;
    cursor: pointer;
    top: 24px;
    left: 24px;
    width: 32px;
    height: 32px;
  }
}
</style>
